import React, { useState } from 'react';

let ModifyContextState = null;

export const ToastContext = React.createContext({
  messages: [],
  setToastMessage: () => {},
});

export const ToastContextProvider = (props) => {
  const setToastMessage = (message) => {
    setState({ ...state, messages: [...state.messages, message] });
  };

  const removeToastMessage = (message) => {
    const withMessageRemoved = state.messages.filter((item) => item !== message);
    setState({ ...state, messages: withMessageRemoved });
  };

  const initState = {
    messages: [],
    setToastMessage: setToastMessage,
  };

  const [state, setState] = useState(initState);

  ModifyContextState = { removeToastMessage, setToastMessage };

  return <ToastContext.Provider value={state}>{props.children}</ToastContext.Provider>;
};

export { ModifyContextState };
